import { ReactNode } from "react";

import { Wrapper, WrapperProps } from "@sso/ui/FlexBox";

interface DialogBodyProps extends WrapperProps {
  children: ReactNode;
}

export const DialogBody = ({ children, ...rest }: DialogBodyProps) => (
  <Wrapper padding="1rem 1.5rem 0.5rem" overflow="auto" width="100%" {...rest}>
    {children}
  </Wrapper>
);
